import { useMemo } from 'react'
import { useResponsiveTier } from '@renderer/hooks/useResponsiveTier'

/**
 * Real viewport metrics for operator overlays (ControlButtons, SettingsModal, PinModal, watermark).
 * `isCompact` matches `useDesignLayout` via unified responsive tiers (see ResponsiveTierProvider in View).
 */
export function useSessionLayout(): {
  /** Narrow or short viewport — touch-optimized chrome */
  isCompact: boolean
  isPortraitViewport: boolean
  isLandscapeViewport: boolean
} {
  const rt = useResponsiveTier()

  return useMemo(
    () => ({
      isCompact: rt.isCompact,
      isPortraitViewport: rt.isPortraitViewport,
      isLandscapeViewport: rt.isLandscapeViewport
    }),
    [rt.isCompact, rt.isPortraitViewport, rt.isLandscapeViewport]
  )
}
